module.exports = __webpack_public_path__ + "assets/01.ec2177c3.pdf";